import React from "react";
import "./Loader.css";

const Loader: React.FC = () => {
  return (
    <div className="loader-overlay">
      <img src="/logo192.png" alt="Loading..." className="loader-logo" />
    </div>
  );
};

export default Loader;
